import Forbidden from './Forbidden'
import Authorized from '.'

const AuthorizedPage = (Component, permissions = [], requires = 'all') => {
  const ComponentWithAuthorization = (props) => {
    return (
      <Authorized permissions={permissions} requires={requires} fallback={<Forbidden />}>
        <Component {...props} />
      </Authorized>
    )
  }

  return ComponentWithAuthorization
}

export default AuthorizedPage
